<template>
  <div class="background">
    <div v-for="(image, index) in list" class="image" :class="{ active: index == active }" :key="image"
        :style="{ backgroundImage: 'url(' + image + ')' }">
    </div>
  </div>
</template>

<script>
const desktop = [
  require('@/assets/Ready1.jpg'),
  require('@/assets/Ready3.jpg'),
  require('@/assets/Ready4.jpg'),
  require('@/assets/Ready6.jpg'),
  require('@/assets/Ready8.jpg'),
  require('@/assets/Ready10.jpg')
];
const mobile = [
  require('@/assets/M1.jpg'),
  require('@/assets/M2.jpg'),
  require('@/assets/M3.jpg'),
  require('@/assets/M4.jpg')
];

let current = 0;

export default {
  data: () => ({
    active: 0,
    list: []
  }),
  mounted: function () {
    // Pick a list based on screen size
    if (window.innerWidth > 800) {
      this.$data.list = desktop;
    } else {
      this.$data.list = mobile;
    }

    const list = this.$data.list;
    console.log('Picked list', list);

    // Warm up cache (maybe add a delay to give #1 priority?)
    list.forEach((image) => {
      var img = new Image();
      img.src = image;
    });

    console.log('Init with image', list[0]);

    // Start the timer
    this.timerId = setInterval(() => {
      this.$data.active += 1;

      if (this.$data.active >= list.length) {
        this.$data.active = 0;
      }

      console.log('Changed to image', list[current]);
    }, 3000);
  },
  beforeDestroy: function () {
    clearInterval(this.timerId);
  }
};
</script>

<style lang="scss">
.background::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(black, 0.45);
}

.image {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  background-size: cover;
  background-position: 50% 50%;
  transition: opacity 0.5s;

  &.active {
    opacity: 1;
  }
}
</style>
